import React, {
  useMemo,
} from 'react';
import Modal from '@mui/material/Modal';
import {
  Box, Tab, Tabs,
} from '@mui/material';
import { useSelector } from 'react-redux';
import DataTable from '../../Common/DataTable';
import {
  selectedTabStyles, stylesTabIndicator, tabsStyles, tabStyles,
} from '../../Common/TabsStyles';
import { Cancel } from '../../media/images/Cancel';
import { RootState } from '../../redux/rootState';
import { Datatablestyle } from './utils/Constant';
import { MorningReportTableData } from './utils/TypeDashboard';
import { PrintIcon } from '../../assets/TableIcons';

interface IMorningReportModal {
  open: boolean;
  handleClose: () => void;
  handlePrinting: () => void;
}

export default function MorningReportModal({
  open, handleClose, handlePrinting,
}: IMorningReportModal) {
  const [activeTab, setActiveTab] = React.useState(1);
  const { morningReportData } = useSelector((state:RootState) => state.dashboardReducer);

  const [receivedReports, overdueReports] = useMemo(() => {
    const overDue = morningReportData?.RecordsForDue?.map((item, index) => ({
      id: String(index + 1),
      jobOrder: item?.JobOrder,
      siteName: item?.Site,
      analyst: item?.Initials,
      receiveDate: item?.ReceiveDate,
      customerName: item?.Customer,
      dateSent: item?.DateSent,
      dueDate: item?.DueDate,
      isCompleted: item?.IsCompleted,
    }));
    const received = morningReportData?.RecordsForMorningReport?.map((item, index) => ({
      id: String(index + 1),
      jobOrder: item?.JobOrder,
      siteName: item?.Site,
      analyst: item?.Initials,
      receiveDate: item?.ReceiveDate,
      customerName: item?.Customer,
      dateSent: item?.DateSent,
      dueDate: item?.DueDate,
      isCompleted: item?.IsCompleted,
    }));
    return [received, overDue];
  }, [morningReportData]);

  const receivedColumns = [
    { key: 'jobOrder', label: 'Job Order #' },
    { key: 'customerName', label: 'Customer Name' },
    { key: 'siteName', label: 'Site Name' },
    { key: 'analyst', label: 'Analyst' },
    { key: 'receiveDate', label: 'Received Date' },
  ];
  const overDueColumns = [
    { key: 'jobOrder', label: 'Job Order #' },
    { key: 'customerName', label: 'Customer Name' },
    { key: 'siteName', label: 'Site Name' },
    { key: 'analyst', label: 'Analyst' },
    { key: 'dateSent', label: 'Date Sent' },
    { key: 'dueDate', label: 'Due Date' },
  ];

  const TABS = [
    { id: 1, label: 'Received Reports' },
    { id: 2, label: 'Overdue Reports' },
  ];

  const handleChangeTab = (tabId: number) => {
    setActiveTab(tabId);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={Datatablestyle}>
        <div className="customerInfo_container flex-row">
          <div className="customerInfo">
            Morning Report
          </div>
          <div className="cancel-icon" onClick={() => handleClose()}>
            <Cancel />
          </div>

        </div>
        <div className="customModalBtnContainer">
          <Tabs
            variant="scrollable"
            value={activeTab - 1}
            onChange={(_, newValue) => handleChangeTab(TABS[newValue].id)}
            style={tabsStyles}
            TabIndicatorProps={stylesTabIndicator}
          >
            {TABS.map((tab) => (
              <Tab
                key={tab.id}
                label={tab.label}
                style={activeTab === tab.id ? selectedTabStyles : tabStyles}
                className="tab_styles"
              />
            ))}
          </Tabs>
          <div className="pointCursor" onClick={handlePrinting}>
            <PrintIcon />
          </div>
        </div>
        <DataTable<MorningReportTableData>
          data={(activeTab === 1 ? receivedReports : overdueReports) || []}
          columns={(activeTab === 1 ? receivedColumns : overDueColumns)}
          handleData={() => {}}
          totalRecords={10}
        />
      </Box>
    </Modal>
  );
}
